var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChiudiOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chiudi-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chiudi-over"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C5.38338462,24 0,18.6166154 0,12 C0,5.38264615 5.38338462,0 12,0 C18.6173538,0 24,5.38264615 24,12 C24,18.6166154 18.6173538,24 12,24 Z",
    id: "3B",
    fill: "#4E565A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.65137,7.34706045 C16.188679,6.88431318 15.4393723,6.88431318 14.9766814,7.34706045 L11.9991941,10.3249102 L9.02170677,7.34706045 C8.55901583,6.88431318 7.80970916,6.88431318 7.34701821,7.34706045 C6.88432726,7.80980772 6.88432726,8.55999526 7.34701821,9.02195286 L10.3245055,11.9998026 L7.34701821,14.978442 C6.88432726,15.4403996 6.88432726,16.1905871 7.34701821,16.6533344 C7.57836368,16.884708 7.88077091,17 8.18396771,17 C8.4871645,17 8.7903613,16.884708 9.02170677,16.6533344 L11.9991941,13.674695 L14.9766814,16.6533344 C15.2080269,16.884708 15.5112237,17 15.8144205,17 C16.1176173,17 16.4200245,16.884708 16.65137,16.6533344 C17.1140609,16.1905871 17.1140609,15.4403996 16.65137,14.978442 L13.6738826,11.9998026 L16.65137,9.02195286 C17.1140609,8.55999526 17.1140609,7.80980772 16.65137,7.34706045",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiudiOver);
export default __webpack_public_path__ + "static/media/chiudi-over.dbe8931c862f4187a287b2bce33543a2.svg";
export { ForwardRef as ReactComponent };